import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/builds/rstewart/api-documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Link } from 'gatsby';
import { Styled } from 'theme-ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`The CitNOW Location ID (LID) is known to the vendor`}</li>
      <li parentName="ul">{`In the case where the vendor wishes to use the Dealer Lookup API to find a LID, the vendor’s dealer codes must be known to CitNOW. (See `}<Styled.a as={Link} to="/dealer-lookup">{`Dealer Lookup API`}</Styled.a>{`)`}</li>
      <li parentName="ul">{`The vendor must work with CitNOW to check their use of the API against a test system ahead of any live roll out.`}</li>
      <li parentName="ul">{`The vendor must be set up on the CitNOW systems. A setup request should be made to CitNOW in advance of any integration work. Email `}<a parentName="li" {...{
          "href": "mailto:support@citnow.com"
        }}>{`support@citnow.com`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "urls"
    }}>{`URLs`}</h2>
    <p>{`CitNOW has a multi node setup, so not all dealers exist on the same server. Unless specifically indicated which server to use, the `}<Styled.a as={Link} to="/dealer-lookup">{`Dealer Lookup API`}</Styled.a>{` should be used to find out the URL for a specific dealer.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`URL`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Test`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://partner-test.citnow.com"
            }}>{`https://partner-test.citnow.com`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Production`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://api-uk.citnow.com"
            }}>{`https://api-uk.citnow.com`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "authentication"
    }}>{`Authentication`}</h2>
    <p>{`Authentication can be achieved by supplying the Vendor Name `}<inlineCode parentName="p">{`vendor`}</inlineCode>{` and Vendor Code `}<inlineCode parentName="p">{`vendor_code`}</inlineCode>{` when making a request. The Vendor Code can be generated by using the IV supplied by CitNOW.`}</p>
    <h2 {...{
      "id": "generating-a-vendor-code"
    }}>{`Generating a Vendor Code`}</h2>
    <p>{`You would have been provided a Vendor Name and Vendor IV when you signed up to access the CitNOW API.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Item`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Vendor Name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plain text that is used to identify a third party`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Vendor IV`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A secret token that is unique to the Vendor. This should be held securely.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`You can generate a `}<inlineCode parentName="p">{`vendor_code`}</inlineCode>{` by combining your Vendor IV with the Location ID `}<inlineCode parentName="p">{`lid`}</inlineCode>{` you are trying to access and then hashing that value using SHA-1.`}</p>
    <p><strong parentName="p">{`Example:`}</strong></p>
    <pre><code parentName="pre" {...{}}>{`If we were provided an IV of: c_RrLcj9eSeXsJpmQMb-DvhAPWrpHrnPYA, and we were trying to access the Location ID: idev

We would first combine the IV and Location ID into one string:
c_RrLcj9eSeXsJpmQMb-DvhAPWrpHrnPYAidev

We would then hash this value using SHA-1, which returns our vendor_code:
cd54c3195e96d7b8673dc1bb5e89098b80dfa962
`}</code></pre>
    <p>{`A `}<inlineCode parentName="p">{`vendor_code`}</inlineCode>{` is unique to only one Location ID. If you want to access multiple Locations, you'll need to generate a `}<inlineCode parentName="p">{`vendor_code`}</inlineCode>{` for each.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      